import React, { useEffect, useRef } from 'react';

const isPlayground = process.env.REACT_APP_ENVIRONMENT === 'playground';

export default function PlaygroundBanner({ fixed = false }) {
  const ref = useRef(null);

  // When fixed, the banner is lifted out of normal flow, so it can't push
  // content down on its own. Publish its (wrap-aware) height as a CSS variable
  // that the layout, header and sidebar use as a top offset. This tracks the
  // taller banner that appears when the text wraps on small screens.
  useEffect(() => {
    if (!isPlayground || !fixed) return undefined;
    const el = ref.current;
    if (!el) return undefined;

    const root = document.documentElement;
    const apply = () => {
      root.style.setProperty('--playground-banner-height', `${el.offsetHeight}px`);
    };
    apply();

    const observer = new ResizeObserver(apply);
    observer.observe(el);
    return () => {
      observer.disconnect();
      root.style.removeProperty('--playground-banner-height');
    };
  }, [fixed]);

  if (!isPlayground) return null;

  const positionClasses = fixed
    ? 'fixed top-0 left-0 right-0 z-[60]'
    : '';

  return (
    <div ref={ref} className={`${positionClasses} bg-amber-100 dark:bg-amber-900/40 border-b border-amber-300/70 dark:border-amber-800/60`}>
      <div className="max-w-7xl 2xl:max-w-[1600px] mx-auto px-6 py-1.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-xs sm:text-[13px] text-amber-900 dark:text-amber-100">
        <span className="font-semibold">Playground Environment</span>
        <span aria-hidden="true" className="opacity-40">·</span>
        <span>Sandbox replicating operational conditions — no prizes are distributed.</span>
        <a href="/playground-info" className="font-medium text-amber-800 dark:text-amber-200 hover:underline underline-offset-2">
          Learn more →
        </a>
      </div>
    </div>
  );
}
